import type { TOC } from '@ember/component/template-only';
import type { ComponentLike } from '@glint/template';
import type { ThComponentSignature } from '@mylighthouse/prism-ember/types/components/prism/table';
import type { Dayjs } from 'dayjs';
import HotelChannelPricingTablesDayTable from 'lumen/components/hotel/channel-pricing/tables/day-table';
import type { Period } from 'lumen/models';

interface HotelChannelPricingTablesDayBarSignature {
  Args: {
    data: Period[];
    isLoading: boolean;
    range: {
      end: Dayjs;
      start: Dayjs;
    };
    thComponent: ComponentLike<ThComponentSignature>;
  };
}

const HotelChannelPricingTablesDayBar = <template>
  <div class="day-bar flex items-center justify-end">
    <HotelChannelPricingTablesDayTable
      @data={{@data}}
      @dateRangeEnd={{@range.end}}
      @dateRangeStart={{@range.start}}
      @isLoading={{@isLoading}}
      @thComponent={{@thComponent}}
    />
  </div>
</template> satisfies TOC<HotelChannelPricingTablesDayBarSignature>;

export default HotelChannelPricingTablesDayBar;
